import React from "react"
import styled from "styled-components"
import { useTranslation } from 'react-i18next';
import facebook from './images/Facebook.png'
import instagram from './images/Instagram.png'
import phone from './images/Phone.png'
import email from './images/Email.png'
import logo from "./images/fullLogo.png"



const Footer = () => {
    const { t } = useTranslation();
return (
    <Div>

<DivLeft>
        <Title><img src={logo} alt="IP Logo"/></Title>
        <P>{t('footer.quote')}</P> 
</DivLeft>

<Maindiv>

<DivRight>
    <DivRows>

        <Column>
            <H1>{t('footer.home')}</H1>
            <Acontact href="/about">{t('header.about')}</Acontact>
            <Acontact href="/Success">{t('success.Success')}</Acontact>
            <Acontact href="/coach">{t('footer.coach')}</Acontact>
            
        </Column>

        <Column>
            <H1>{t('footer.clients')}</H1>
            <Acontact href="/shop">Shop</Acontact>
            <Acontact href="/consultation">{t('footer.consultation')}</Acontact>
            <Acontact href="/signup">{t('login.signup')}</Acontact>
            
        </Column>

        <Column>
            <H1>{t('footer.contact')}</H1>
            <span>
                <Acontact href="/contact"> <IMG src= {email} alt= "Email Icon" /></Acontact> 
                <Acontact href="https://www.instagram.com/ipvirtuel"> <IMG src= {instagram} alt="Instagram Icon" /></Acontact>
                <Acontact href="https://www.facebook.com/profile.php?id=61575227243148"> <IMG src= {facebook} alt="Facebook Icon" /></Acontact>
                <Acontact href="/contact"><IMG src= {phone} alt="Phone Icon" /></Acontact> 
            </span>
            {/* <p>{t('footer.opp')}</p> */}
            <Acontact href="/termes-et-conditions"><p>{t('footer.t&c')}</p></Acontact>
            <Acontact href="/faq">{t('footer.FAQ')}</Acontact>
            {/* <Acontact href="/privacypolicy"><p>{t('footer.pp')}</p></Acontact>  */}
            
        
            
        </Column>

    </DivRows>
</DivRight>

</Maindiv>

<DivBottom>
        <A href="#">{t('footer.top')}</A>
</DivBottom>

<SITEDIV>
<Aoursite href="https://mail.google.com/mail/?view=cm&fs=1&to=mathieujoyal96@gmail.com&su=Info%20Pour%20Site&body=Votre%20Message" target="_blank" rel="noopener noreferrer">{t('footer.OURsite')} DreamDevStudio </Aoursite>
</SITEDIV>
</Div>
);
}

export default Footer

const SITEDIV = styled.div`
text-align: center;
margin-top: 15px;
padding-bottom: -30px;
`

const Aoursite = styled.a`
color: black;
opacity: 70%;
font-size: 14px;
`

const Title = styled.p`
    color: black;
    font-size: 30px;
    font-weight: bold;
`

const Maindiv = styled.div`
 font-family: 'Montserrat', sans-serif;
  font-weight: 500;
background-color: white;
display: flex;
justify-content: center;
`

const DivLeft = styled.div`
text-align: center;
border-top: 3px solid green;
`

const DivRight = styled.div`
flex: 2 1 50%;
`

const H1 = styled.h1`
color: green;
font-family: 'Great Vibes', cursive;
font-size: 45px;
margin-bottom: -5px;
`


const P = styled.p`
margin-top: -25px;
font-family: cursive;
font-style: italic;
`

const DivRows = styled.div`
margin-top: -30px;
display: flex;
justify-content: center;
`

const Column = styled.div`
flex: 1 1 30%;
display: flex;
flex-direction: column;  
align-items: center;  
text-align: center;  

`

const DivBottom = styled.div`
display: flex;
justify-content: center;  
align-items: center;  
`

const Div = styled.div`
background-color: white;
padding-bottom: 20px;
`

const IMG  = styled.img`
width: 30px;
`

const Acontact = styled.a`
text-decoration: none;
color: black;
margin: 5px;
//margin-top: 10px;
`

const A = styled.a`
text-decoration: none;
background-color: green;
 color: white;
 padding: 12px;
 border: none;
 border-radius: 20px;
 font-weight: bold;
 font-style: none;
 cursor: pointer;
`